

export enum ActionTypeEnum {
    Download = 0,
    Notify = 1,
    Import = 2
}


export enum StatusEnum {
    Started = 0,
    CollectingData = 1,
    CreatingFile = 2,
    Completed = 3,
    Failed = 4
}

export interface IExportNotificationMsg {
    action: ActionTypeEnum;
    notificationID: string;
    status: StatusEnum;
    statusMessage: string;
    additionalInfo: string;
    blobURI: string;
    fileStoreID?: number;
    percentComplete: number;
    temporary?: boolean;
    import?: boolean;
}

